export default function Section({ title, children }) {
	return (
		<div className="bg-white border border-[#E6E2D6] rounded-sm p-6">
			<h2 className="text-lg font-semibold text-[#1A3C34] font-['Playfair_Display'] mb-4">{title}</h2>
			{children}
		</div>
	);
}